export const lime = {
  190: '#121600',
  175: '#2E3700',
  150: '#5C6E00',
  125: '#8AA400',
  100: '#B8DB00',
  75: '#CAE440',
  50: '#DBED80',
  25: '#EDF6BF',
  10: '#F8FBE5',
  5: '#fbfff0',
};

export type LimeVariants = keyof typeof lime;
